"use client";
import { useEffect, useState } from "react";
import { useSearchParams } from "next/navigation";

import { useStore, observer } from "../../service/mobx";

function HooksDocs() {
  const { analytics, reader } = useStore();
  const _c = useSearchParams().get("_c");
  const [whiteLabelled, setWhiteLabelled] = useState(_c);

  useEffect(() => {
    const whiteLabelled = sessionStorage.getItem("whiteLabelled");

    if (whiteLabelled) {
      setWhiteLabelled(whiteLabelled);
    }
  }, []);

  useEffect(() => {
    if (_c) {
      setWhiteLabelled(_c);
    }
  }, [reader, _c]);

  useEffect(() => {
    if (whiteLabelled) {
      try {
        const { disable, related = [] } = JSON.parse(atob(whiteLabelled));
        var successSignal = "1";

        reader.set.config({
          disable: disable ? new Set(disable) : undefined,
          related: new Set([...related, "authors"])
        });

        [
          document.getElementById("pane"),
          document.getElementById("rail")
        ].forEach(element => {
          if (element) {
            element.style.display = "none";
          }
        });

        document.body.style.border = "1px solid rgb(238, 238, 238)";
        sessionStorage.setItem("whitelabelled", whiteLabelled);
      } catch (error) {
        successSignal = "0";
        console.error(error);
      } finally {
        analytics.track.event("Whitelabel");
        setTimeout(window.parent?.postMessage, 2e3, successSignal, "*");
      }
    }

    reader.set.checkedForWhiteLabel(true);
  }, [analytics, reader, whiteLabelled]);

  useEffect(() => {
    // set context
    analytics.set.context("Docs", "View");
    // remove context when component unmounts
    return () => {
      reader.reset();
      analytics.set.context();
    };
  }, [analytics, reader]);
}

export function PageHooksDocs({ paperJSON, paperNode, publisher, paperID }) {
  const { reader } = useStore();

  useEffect(() => {
    if (reader.publisher !== publisher || reader.paperID !== paperID) {
      reader.set.publisher(publisher);
      reader.set.paperID(paperID);
      reader.set.article(paperJSON);
      reader.set.paperNode(paperNode);

      return () => {
        if (reader.publisher !== publisher || reader.paperID !== paperID) {
          reader.set.related();
        }
      };
    }
  }, [reader, publisher, paperID, paperJSON, paperNode]);
}

export default observer(HooksDocs);
